import appCode from "@common/src/utils/app-code";
const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryRecordList({ rootState }, params = {}) {
      const pathMap = {
        speedbiz: "/warranty/card/queryList",
        "speedbiz-operation": "/op/warranty/card/queryList"
      };
      const data = await rootState.http(pathMap[appCode], params);
      return data;
    },
    // op端不能发邮件
    async restSendEmail({ rootState }, params = {}) {
      const data = await rootState.http("/warranty/card/restSendEmail", params);
      return data;
    },
    async queryWarrantyClaimsList({ rootState }, params = {}) {
      const data = await rootState.http("/op/warranty/claimApply/query", params);
      return data;
    },
    async claimsApplyAudit({ rootState }, params = {}) {
      const data = await rootState.http("/op/warranty/claimApply/audit", params);
      return data;
    },
    async claimsApplyDownload({ rootState }, params = {}) {
      const data = await rootState.http("/op/warranty/claimApply/query/download", params);
      return data;
    },
    async queryWarrantyClaimsDetail({ rootState }, params = {}) {
      const data = await rootState.http("/op/warranty/claimApply/detail", params);
      return data;
    }
  }
};

export default store;
